import React from 'react';
import PropTypes from 'prop-types';
import MuiSnackbar from '@mui/material/Snackbar';
import { styled } from '@mui/system';

import { CHILDREN_PROP_TYPES } from 'propTypes';
import { getButtonBackgroundHoverColor } from 'styles/helpers/getThemeStyles';

const StyledSnackbar = styled(MuiSnackbar)(({ theme }) => ({
  '&.MuiSnackbar-root': {
    position: 'initial',
    transform: 'initial',
    marginBottom: '20px',
    '& .MuiSnackbarContent-root': {
      backgroundColor: getButtonBackgroundHoverColor(theme),
      width: '396px',
      borderRadius: '8px',
      paddingLeft: '18px'
    },
    [theme.breakpoints.down('sm')]: {
      margin: '5px 20px 0'
    }
  }
}));

function AlertSnackbar({ open, message, onClose, horizontal, vertical }) {
  return (
    <StyledSnackbar
      open={open}
      onClose={onClose}
      message={message}
      anchorOrigin={{
        horizontal: horizontal,
        vertical: vertical
      }}
    />
  );
}

AlertSnackbar.defaultProps = {
  open: false,
  onClose: () => {},
  horizontal: 'center',
  vertical: 'top'
};

AlertSnackbar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  message: CHILDREN_PROP_TYPES.isRequired,
  horizontal: PropTypes.string,
  vertical: PropTypes.string
};

export default AlertSnackbar;
